<template>
  <!-- 邀请码 -->
  <div class="invitaionCode menu-item-r">
    <div class="invitaionCodeBanner">
        <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/invitationCode/invitationCodeImg.png"/>
    </div>
    <div class="invitaionCodeMain">
        <div class="invitaionCodeMainBox">
             

            <p class="codeTitle">{{ $t('invitationCode') }}</p>
            <p class="code">{{code}}</p>
            <div class="codeTips">
                <p>{{ $t('invitationCodeTips1') }}</p>
                <p>{{ $t('invitationCodeTips2') }}</p>
                <p>{{ $t('invitationCodeTips3') }}</p>
            </div>
            <div class="but">
                <span 
                    type="primary" 
                    class="copy-btn"
                    v-clipboard:copy="code"
                    v-clipboard:success="onCopy"><p>{{ $t('clickCopy') }}</p></span>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
// import invitationCodeImg from '@/assets/images/invitationCodeImg.png'
import { mapGetters } from 'vuex'
import { getInviteCode } from '@/api/index'
export default {
  data () {
    return {
      // invitationCodeImg:invitationCodeImg,
      code:'',
    }
  },
  mounted () {
    getInviteCode().then(res => {
      if (res.data.code == 1000 && res.data.data) {
        this.code = res.data.data;
      }
    })
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  methods: {
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        message: this.$t('Copied'),
        type: 'success'
      })
    },
    
  }
}
</script>
<style lang="stylus">
    .invitaionCode{

        .invitaionCodeBanner{
            margin-top 30px
            width 100%
            height 224px
            img{
                width 100%
                height 100%
            }
        }
        .invitaionCodeMain{
            width 100%
            background $color-gray-fb
            padding-bottom 20px
        }
        .invitaionCodeMainBox{
            width 400px
            margin 0 auto
            .codeTitle{
              font-weight 600
              font-size 18px
              text-align center
              padding-top 72px
              color $color-black-65
            }
            .code{
                width 400px
                height 72px
                line-height: 72px;
                font-size 50px
                margin 40px 0;
                background $color-white;
                text-align center
                color $color-blue-a6
                font-weight bold
            }
            .codeTips{
                font-size 14px
                color $color-black-45
                margin-left 40px
                p{
                    line-height 1.666
                }
            }
            .but{
                width 320px
                text-align center
                margin 40px
                .copy-btn{
                    width 320px
                    height 48px
                    display block
                    background $color-main;
                    color $color-white;
                    text-align center
                    line-height 48px
                    border-radius 5px
                    font-size 18px
                    cursor:pointer
                }
            }
        }
    }
</style>
